export default defineNuxtRouteMiddleware((to, _from) => {
	if (to.fullPath.includes("maintenance")) return;

	const config = useRuntimeConfig();

	if (config.public.maintenance === false) return;
	if (useCookie("dj_dev_mode").value) return;

	const { locale } = useNuxtApp().$i18n;
	return navigateTo(`/${locale.value}/maintenance`);
});
